import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DevOpsPlaceholderCardComponent } from '../devops-placeholder-card/devops-placeholder-card.component';

@Component({
  selector: 'app-devops-kpis',
  imports: [DevOpsPlaceholderCardComponent],
  templateUrl: './devops-kpis.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevOpsKpisComponent {}
